import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { CloudUpload, AutoAwesome, Explore } from '@mui/icons-material';

const steps = [
  { icon: <CloudUpload sx={{ fontSize: 48 }} />, title: 'Upload', desc: 'Share a photo of your outfit with details like occasion, brands, and tags.' },
  { icon: <AutoAwesome sx={{ fontSize: 48 }} />, title: 'AI Analysis', desc: 'Our AI identifies clothing items, colors, and styles to help others discover your look.' },
  { icon: <Explore sx={{ fontSize: 48 }} />, title: 'Discover', desc: 'Browse trending outfits, rate looks you love, and build your personal style feed.' },
];

const HowItWorks: React.FC = () => (
  <Box sx={{ py: 4 }}>
    <Typography variant="h4" component="h2" sx={{ fontWeight: 700, mb: 3, textAlign: 'center' }}>
      How It Works
    </Typography>
    <Grid container spacing={3}>
      {steps.map((step, i) => (
        <Grid item xs={12} md={4} key={i}>
          <Paper sx={{ p: 3, textAlign: 'center', height: '100%' }}>
            <Box sx={{ color: 'primary.main', mb: 1 }}>{step.icon}</Box>
            <Typography variant="h6" gutterBottom>{step.title}</Typography>
            <Typography variant="body2" color="text.secondary">{step.desc}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default HowItWorks;
